import script from "./LogInComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./LogInComponent.vue?vue&type=script&setup=true&lang=js"

import "./LogInComponent.vue?vue&type=style&index=0&id=fc5055e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc5055e2"]])

export default __exports__